import styled from 'styled-components';
import { AngleBackIcon, CloseIcon } from '@/components/UI/Icons/Icons';
import { getMaskIconStyles } from '@/styles/helpers';

export const SearchRegionSelectWrapper = styled.div`
  position: relative;
`;

export const SearchRegionSelectBox = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
`;

export const SearchRegionSelectContent = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 104px;
  height: 40px;
  gap: 5px;
  padding: 0 14px 0 9.5px;
  border-left: 1px solid ${({ theme }) => theme.palette.secondary.border};

  @media (min-width: 1025px) {
    width: 160px;
  }
`;

export const SearchRegionSelectCloseIcon = styled(CloseIcon).attrs(
  ({ theme }) => ({
    width: 10,
    height: 10,
    fill: theme.palette.brand.main,
  })
)`
  min-width: 10px;
  cursor: pointer;
`;

export const SearchRegionSelectIcon = styled.div<{
  $isDropdownOpen: boolean;
}>`
  background-color: ${({ $isDropdownOpen, theme }) =>
    $isDropdownOpen
      ? theme.palette.brand.main
      : theme.palette.secondary.labels};

  ${getMaskIconStyles('location.svg', 10, 14)};
`;

export const SearchRegionSelectInput = styled.input`
  width: 100%;
  padding: 1px 1.5px;
  border: 0;
  outline: 0;
  font-size: 15px;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ theme }) => theme.palette.primary.labels};

  &::placeholder {
    color: ${({ theme }) => theme.palette.secondary.labels};
  }
`;

export const SearchRegionSelectAngleIcon = styled(AngleBackIcon).attrs(
  ({ theme }) => ({
    height: 12.75,
    fill: theme.palette.secondary.labels,
  })
)<{
  $isDropdownOpen: boolean;
}>`
  min-width: 12.75px;
  transform: ${({ $isDropdownOpen }) =>
    $isDropdownOpen ? 'rotate(90deg)' : 'rotate(-90deg)'};
`;
